module.exports = __webpack_public_path__ + "img/lkLogo.4b976f51.jpg";